import React from 'react';
import { TextAreaInputWUT } from '../../inputs/text-area-input-wut/text-area-input-wut';
import { useFieldAttributes } from '../../sdk/components';
import { FieldDescriptionWUT, FieldErrorWUT, FieldLabelWUT } from '../../sdk/components-wut';
export const TextAreaFieldWUT = ({ id, target, label, hideLabel, placeholder, required, value, onChange, onFocus, onBlur, error, hasError = false, errorMessage, disabled = false, readOnly, description, FieldLayout, requiredIndicatorType, requiredIndicatorPlacement })=>{
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                htmlFor: inputId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement
            }),
        renderInput: ()=>/*#__PURE__*/ React.createElement(TextAreaInputWUT, {
                label: label,
                placeholder: placeholder,
                required: required,
                value: value,
                onChange: onChange,
                onFocus: onFocus,
                onBlur: onBlur,
                disabled: disabled,
                readOnly: readOnly,
                inputId: inputId,
                hasError: hasError,
                ariaDescribedBy: ariaDescribedBy,
                fieldId: id
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};

//# sourceMappingURL=text-area-field-wut.js.map